"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buttonTokens = void 0;
const Global_1 = require("../../DesignSystem/tokens/Global");
const DesignToken_1 = __importDefault(require("../../DesignSystem/types/DesignToken"));
const GlobalDesignToken_1 = require("../../DesignSystem/types/GlobalDesignToken");
// Border width
const buttonBorderWidth = new DesignToken_1.default({
    name: 'button-borderWidth',
    parent: [Global_1.globalTokens.borderWidthS, Global_1.globalTokens.oldTokens.borderWidthS]
});
// Height
const buttonHeightS = new DesignToken_1.default({
    name: 'button-height-s',
    parent: [Global_1.globalTokens.controlSizeS, Global_1.globalTokens.oldTokens.sizeXL]
});
const buttonHeightM = new DesignToken_1.default({
    name: 'button-height-m',
    parent: [Global_1.globalTokens.controlSizeM, Global_1.globalTokens.oldTokens.sizeXL]
});
const buttonHeightL = new DesignToken_1.default({
    name: 'button-height-l',
    parent: [Global_1.globalTokens.controlSizeL, Global_1.globalTokens.oldTokens.sizeXL]
});
const buttonHeightSMinWidth = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'button-height-s-minWidth',
    fallback: '0px'
});
const buttonHeightMMinWidth = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'button-height-s-minWidth',
    fallback: '0px'
});
const buttonHeightLMinWidth = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'button-height-s-minWidth',
    fallback: '0px'
});
const buttonHeightSFontSize = new DesignToken_1.default({
    name: 'button-height-s-font-size',
    parent: [Global_1.globalTokens.fontSizeS, Global_1.globalTokens.oldTokens.fontSizeM]
});
const buttonHeightSFontWeight = new DesignToken_1.default({
    name: 'button-height-s-font-weight',
    parent: [Global_1.globalTokens.fontWeightMedium, Global_1.globalTokens.oldTokens.fontWeightNormal]
});
const buttonHeightSLineHeight = new DesignToken_1.default({
    name: 'button-height-s-line-height',
    parent: [Global_1.globalTokens.lineHeightS, Global_1.globalTokens.oldTokens.lineHeightM]
});
const buttonHeightMFontSize = new DesignToken_1.default({
    name: 'button-height-m-font-size',
    parent: [Global_1.globalTokens.fontSizeM, Global_1.globalTokens.oldTokens.fontSizeM]
});
const buttonHeightMFontWeight = new DesignToken_1.default({
    name: 'button-height-m-font-weight',
    parent: [Global_1.globalTokens.fontWeightMedium, Global_1.globalTokens.oldTokens.fontWeightNormal]
});
const buttonHeightMLineHeight = new DesignToken_1.default({
    name: 'button-height-m-line-height',
    parent: [Global_1.globalTokens.lineHeightM, Global_1.globalTokens.oldTokens.lineHeightM]
});
const buttonHeightLFontSize = new DesignToken_1.default({
    name: 'button-height-l-font-size',
    parent: [Global_1.globalTokens.fontSizeM, Global_1.globalTokens.oldTokens.fontSizeM]
});
const buttonHeightLFontWeight = new DesignToken_1.default({
    name: 'button-height-l-font-weight',
    parent: [Global_1.globalTokens.fontWeightMedium, Global_1.globalTokens.oldTokens.fontWeightNormal]
});
const buttonHeightLLineHeight = new DesignToken_1.default({
    name: 'button-height-l-line-height',
    parent: [Global_1.globalTokens.lineHeightM, Global_1.globalTokens.oldTokens.lineHeightM]
});
// Border radius
const buttonHeightSBorderRadius = new DesignToken_1.default({
    name: 'button-height-s-border-radius',
    parent: [Global_1.globalTokens.borderRadiusS, Global_1.globalTokens.oldTokens.borderRadiusNone]
});
const buttonHeightMBorderRadius = new DesignToken_1.default({
    name: 'button-height-m-border-radius',
    parent: [Global_1.globalTokens.borderRadiusM, Global_1.globalTokens.oldTokens.borderRadiusNone]
});
const buttonHeightLBorderRadius = new DesignToken_1.default({
    name: 'button-height-l-border-radius',
    parent: [Global_1.globalTokens.borderRadiusM, Global_1.globalTokens.oldTokens.borderRadiusNone]
});
// Indents
const buttonHeightSIconMargin = new DesignToken_1.default({
    name: 'button-height-s-icon-margin',
    parent: [Global_1.globalTokens.sizeXS, Global_1.globalTokens.oldTokens.sizeSpaceS]
});
const buttonHeightMIconMargin = new DesignToken_1.default({
    name: 'button-height-m-icon-margin',
    parent: [Global_1.globalTokens.sizeS, Global_1.globalTokens.oldTokens.sizeSpaceS]
});
const buttonHeightLIconMargin = new DesignToken_1.default({
    name: 'button-height-l-icon-margin',
    parent: [Global_1.globalTokens.sizeS, Global_1.globalTokens.oldTokens.sizeSpaceS]
});
// Paddings
const buttonHeightSPaddingHorizontal = new DesignToken_1.default({
    name: 'button-height-s-paddingHorizontal',
    parent: [Global_1.globalTokens.spacingS, Global_1.globalTokens.oldTokens.sizeSpaceM]
});
const buttonHeightMPaddingHorizontal = new DesignToken_1.default({
    name: 'button-height-m-paddingHorizontal',
    parent: [Global_1.globalTokens.spacingSM, Global_1.globalTokens.oldTokens.sizeSpaceM]
});
const buttonHeightLPaddingHorizontal = new DesignToken_1.default({
    name: 'button-height-L-paddingHorizontal',
    parent: [Global_1.globalTokens.spacingSM, Global_1.globalTokens.oldTokens.sizeSpaceM]
});
// Disabled
const buttonDisabledIconFilter = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'button-disabled-icon-filter',
    fallback: 'grayscale(100%)'
});
const buttonDisabledIconOpacity = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'button-disabled-icon-opacity',
    fallback: '0.5'
});
// Primary
const buttonPrimaryBackgroundColor = new DesignToken_1.default({
    name: 'button-primary-backgroundColor',
    parent: [Global_1.globalTokens.colorBackgroundBrandDefault, Global_1.globalTokens.oldTokens.colorButtonRest]
});
const buttonPrimaryHoverBackgroundColor = new DesignToken_1.default({
    name: 'button-primary-hover-backgroundColor',
    parent: [Global_1.globalTokens.colorBackgroundBrandHover, Global_1.globalTokens.oldTokens.colorButtonHover]
});
const buttonPrimaryActiveBackgroundColor = new DesignToken_1.default({
    name: 'button-primary-active-backgroundColor',
    parent: [Global_1.globalTokens.colorBackgroundBrandActive, Global_1.globalTokens.oldTokens.colorButtonActive]
});
const buttonPrimaryFocusBackgroundColor = new DesignToken_1.default({
    name: 'button-primary-focus-backgroundColor',
    parent: [Global_1.globalTokens.colorBackgroundBrandDefault, Global_1.globalTokens.oldTokens.colorButtonHover]
});
const buttonPrimaryTextColor = new DesignToken_1.default({
    name: 'button-primary-textColor',
    parent: [
        Global_1.globalTokens.colorForegroundDefaultInverted,
        Global_1.globalTokens.oldTokens.colorTextRestButton
    ]
});
const buttonPrimaryHoverTextColor = new DesignToken_1.default({
    name: 'button-primary-hover-textColor',
    parent: [
        Global_1.globalTokens.colorForegroundDefaultInverted,
        Global_1.globalTokens.oldTokens.colorTextRestButton
    ]
});
const buttonPrimaryActiveTextColor = new DesignToken_1.default({
    name: 'button-primary-active-textColor',
    parent: [
        Global_1.globalTokens.colorForegroundDefaultInverted,
        Global_1.globalTokens.oldTokens.colorTextRestButton
    ]
});
const buttonPrimaryFocusTextColor = new DesignToken_1.default({
    name: 'button-primary-focus-textColor',
    parent: [
        Global_1.globalTokens.colorForegroundDefaultInverted,
        Global_1.globalTokens.oldTokens.colorTextRestButton
    ]
});
const buttonPrimaryBorderColor = new DesignToken_1.default({
    name: 'button-primary-borderColor',
    parent: [Global_1.globalTokens.colorBackgroundBrandDefault, Global_1.globalTokens.oldTokens.colorButtonRest]
});
const buttonPrimaryHoverBorderColor = new DesignToken_1.default({
    name: 'button-primary-hover-borderColor',
    parent: [Global_1.globalTokens.colorBackgroundBrandHover, Global_1.globalTokens.oldTokens.colorButtonHover]
});
const buttonPrimaryActiveBorderColor = new DesignToken_1.default({
    name: 'button-primary-active-borderColor',
    parent: [Global_1.globalTokens.colorBackgroundBrandActive, Global_1.globalTokens.oldTokens.colorButtonActive]
});
const buttonPrimaryFocusBorderColor = new DesignToken_1.default({
    name: 'button-primary-focus-borderColor',
    parent: [Global_1.globalTokens.colorBackgroundBrandDefault, Global_1.globalTokens.oldTokens.colorButtonHover]
});
const buttonPrimaryDisabledBorderColor = new DesignToken_1.default({
    name: 'button-primary-disabled-borderColor',
    parent: [
        Global_1.globalTokens.colorBackgroundDefaultDisabled,
        Global_1.globalTokens.oldTokens.colorButtonDisabled
    ]
});
const buttonPrimaryDisabledBackgroundColor = new DesignToken_1.default({
    name: 'button-primary-disabled-backgroundColor',
    parent: [
        Global_1.globalTokens.colorBackgroundDefaultDisabled,
        Global_1.globalTokens.oldTokens.colorButtonDisabled
    ]
});
const buttonPrimaryDisabledTextColor = new DesignToken_1.default({
    name: 'button-primary-disabled-textColor',
    parent: [
        Global_1.globalTokens.colorForegroundDefaultDisabled,
        Global_1.globalTokens.oldTokens.colorTextButtonDisabled
    ]
});
// Secondary
const buttonSecondaryTextColor = new DesignToken_1.default({
    name: 'button-secondary-textColor',
    parent: [
        Global_1.globalTokens.colorForegroundDefaultPrimary,
        Global_1.globalTokens.oldTokens.colorTextRestSecondaryButton
    ]
});
const buttonSecondaryHoverTextColor = new DesignToken_1.default({
    name: 'button-secondary-hover-textColor',
    parent: [
        Global_1.globalTokens.colorForegroundDefaultPrimary,
        Global_1.globalTokens.oldTokens.colorTextRestSecondaryButton
    ]
});
const buttonSecondaryActiveTextColor = new DesignToken_1.default({
    name: 'button-secondary-active-textColor',
    parent: [
        Global_1.globalTokens.colorForegroundDefaultPrimary,
        Global_1.globalTokens.oldTokens.colorTextRestSecondaryButton
    ]
});
const buttonSecondaryFocusTextColor = new DesignToken_1.default({
    name: 'button-secondary-focus-textColor',
    parent: [Global_1.globalTokens.colorForegroundDefaultPrimary, buttonSecondaryHoverTextColor]
});
const buttonSecondaryBackgroundColor = new DesignToken_1.default({
    name: 'button-secondary-backgroundColor',
    parent: [
        Global_1.globalTokens.colorForegroundDefaultTransparent,
        Global_1.globalTokens.oldTokens.colorSecondaryButton
    ]
});
const buttonSecondaryHoverBackgroundColor = new DesignToken_1.default({
    name: 'button-secondary-hover-backgroundColor',
    parent: [
        Global_1.globalTokens.colorBackgroundDefaultHover,
        Global_1.globalTokens.oldTokens.colorSecondaryButtonHover
    ]
});
const buttonSecondaryActiveBackgroundColor = new DesignToken_1.default({
    name: 'button-secondary-active-backgroundColor',
    parent: [
        Global_1.globalTokens.colorBackgroundDefaultActive,
        Global_1.globalTokens.oldTokens.colorSecondaryButtonActive
    ]
});
const buttonSecondaryFocusBackgroundColor = new DesignToken_1.default({
    name: 'button-secondary-focus-backgroundColor',
    parent: [Global_1.globalTokens.colorForegroundDefaultTransparent, buttonSecondaryHoverBackgroundColor]
});
const buttonSecondaryBorderColor = new DesignToken_1.default({
    name: 'button-secondary-borderColor',
    parent: [Global_1.globalTokens.colorStrokeDefaultDefault, Global_1.globalTokens.oldTokens.colorSecondaryButton]
});
const buttonSecondaryHoverBorderColor = new DesignToken_1.default({
    name: 'button-secondary-hover-borderColor',
    parent: [
        Global_1.globalTokens.colorBackgroundDefaultHover,
        Global_1.globalTokens.oldTokens.colorSecondaryButtonHover
    ]
});
const buttonSecondaryActiveBorderColor = new DesignToken_1.default({
    name: 'button-secondary-active-borderColor',
    parent: [
        Global_1.globalTokens.colorBackgroundDefaultActive,
        Global_1.globalTokens.oldTokens.colorSecondaryButtonActive
    ]
});
const buttonSecondaryFocusBorderColor = new DesignToken_1.default({
    name: 'button-secondary-focus-borderColor',
    parent: [Global_1.globalTokens.colorForegroundDefaultTransparent, buttonSecondaryHoverBorderColor]
});
const buttonSecondaryDisabledBorderColor = new DesignToken_1.default({
    name: 'button-secondary-disabled-borderColor',
    parent: [Global_1.globalTokens.colorStrokeDefaultDisabled, Global_1.globalTokens.oldTokens.colorButtonDisabled]
});
const buttonSecondaryDisabledBackgroundColor = new DesignToken_1.default({
    name: 'button-secondary-disabled-backgroundColor',
    parent: [
        Global_1.globalTokens.colorForegroundDefaultTransparent,
        Global_1.globalTokens.oldTokens.colorButtonDisabled
    ]
});
const buttonSecondaryDisabledTextColor = new DesignToken_1.default({
    name: 'button-secondary-disabled-textColor',
    parent: [
        Global_1.globalTokens.colorForegroundDefaultDisabled,
        Global_1.globalTokens.oldTokens.colorTextButtonDisabled
    ]
});
// Alternate
const buttonAlternateTextColor = new DesignToken_1.default({
    name: 'button-alternate-textColor',
    parent: [
        Global_1.globalTokens.colorForegroundDefaultPrimary,
        Global_1.globalTokens.oldTokens.colorTextRestGhostButton
    ]
});
const buttonAlternateHoverTextColor = new DesignToken_1.default({
    name: 'button-alternate-hover-textColor',
    parent: [Global_1.globalTokens.colorForegroundDefaultPrimary, Global_1.globalTokens.oldTokens.colorTextRestButton]
});
const buttonAlternateActiveTextColor = new DesignToken_1.default({
    name: 'button-alternate-active-textColor',
    parent: [Global_1.globalTokens.colorForegroundDefaultPrimary, Global_1.globalTokens.oldTokens.colorTextRestButton]
});
const buttonAlternateFocusTextColor = new DesignToken_1.default({
    name: 'button-alternate-focus-textColor',
    parent: [Global_1.globalTokens.colorForegroundDefaultPrimary, buttonAlternateHoverTextColor]
});
const buttonAlternateBorderColor = new DesignToken_1.default({
    name: 'button-alternate-borderColor',
    parent: [
        Global_1.globalTokens.colorStrokeDefaultDefault,
        Global_1.globalTokens.oldTokens.colorGhostButtonBorderRest
    ]
});
const buttonAlternateHoverBorderColor = new DesignToken_1.default({
    name: 'button-alternate-hover-borderColor',
    parent: [Global_1.globalTokens.colorBackgroundDefaultHover, Global_1.globalTokens.oldTokens.colorButtonHover]
});
const buttonAlternateActiveBorderColor = new DesignToken_1.default({
    name: 'button-alternate-active-borderColor',
    parent: [Global_1.globalTokens.colorBackgroundDefaultActive, Global_1.globalTokens.oldTokens.colorButtonActive]
});
const buttonAlternateFocusBorderColor = new DesignToken_1.default({
    name: 'button-alternate-focus-borderColor',
    parent: [Global_1.globalTokens.colorForegroundDefaultTransparent, buttonAlternateHoverBorderColor]
});
const buttonAlternateBackgroundColor = new DesignToken_1.default({
    name: 'button-alternate-backgroundColor',
    parent: [
        Global_1.globalTokens.colorForegroundDefaultTransparent,
        Global_1.globalTokens.oldTokens.colorBackgroundBlank
    ]
});
const buttonAlternateHoverBackgroundColor = new DesignToken_1.default({
    name: 'button-alternate-hover-backgroundColor',
    parent: [Global_1.globalTokens.colorBackgroundDefaultHover, Global_1.globalTokens.oldTokens.colorButtonHover]
});
const buttonAlternateActiveBackgroundColor = new DesignToken_1.default({
    name: 'button-alternate-active-backgroundColor',
    parent: [Global_1.globalTokens.colorBackgroundDefaultActive, Global_1.globalTokens.oldTokens.colorButtonActive]
});
const buttonAlternateFocusBackgroundColor = new DesignToken_1.default({
    name: 'button-alternate-focus-backgroundColor',
    parent: [Global_1.globalTokens.colorForegroundDefaultTransparent, buttonAlternateHoverBackgroundColor]
});
const buttonAlternateDisabledBorderColor = new DesignToken_1.default({
    name: 'button-alternate-disabled-borderColor',
    parent: [Global_1.globalTokens.colorStrokeDefaultDisabled, Global_1.globalTokens.oldTokens.colorButtonDisabled]
});
const buttonAlternateDisabledBackgroundColor = new DesignToken_1.default({
    name: 'button-alternate-disabled-backgroundColor',
    parent: [
        Global_1.globalTokens.colorForegroundDefaultTransparent,
        Global_1.globalTokens.oldTokens.colorButtonDisabled
    ]
});
const buttonAlternateDisabledTextColor = new DesignToken_1.default({
    name: 'button-alternate-disabled-textColor',
    parent: [
        Global_1.globalTokens.colorForegroundDefaultDisabled,
        Global_1.globalTokens.oldTokens.colorTextButtonDisabled
    ]
});
// Text
const buttonTextHeightSPaddingHorizontal = new DesignToken_1.default({
    name: 'button-text-height-s-paddingHorizontal',
    parent: [Global_1.globalTokens.spacingS, Global_1.globalTokens.oldTokens.sizeSpaceNone]
});
const buttonTextHeightMPaddingHorizontal = new DesignToken_1.default({
    name: 'button-text-height-m-paddingHorizontal',
    parent: [Global_1.globalTokens.spacingSM, Global_1.globalTokens.oldTokens.sizeSpaceNone]
});
const buttonTextHeightLPaddingHorizontal = new DesignToken_1.default({
    name: 'button-text-height-l-paddingHorizontal',
    parent: [Global_1.globalTokens.spacingSM, Global_1.globalTokens.oldTokens.sizeSpaceNone]
});
const buttonTextBorderWidth = new DesignToken_1.default({
    name: 'button-text-borderWidth',
    parent: [Global_1.globalTokens.borderWidthS, Global_1.globalTokens.oldTokens.borderWidthNone]
});
const buttonTextDecoration = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'button-text-decoration',
    fallback: 'underline'
});
const buttonTextTextColor = new DesignToken_1.default({
    name: 'button-text-textColor',
    parent: [Global_1.globalTokens.colorForegroundDefaultPrimary, Global_1.globalTokens.oldTokens.colorLink]
});
const buttonTextHoverTextColor = new DesignToken_1.default({
    name: 'button-text-hover-textColor',
    parent: [Global_1.globalTokens.colorForegroundDefaultPrimary, Global_1.globalTokens.oldTokens.colorLink]
});
const buttonTextActiveTextColor = new DesignToken_1.default({
    name: 'button-text-active-textColor',
    parent: [Global_1.globalTokens.colorForegroundDefaultPrimary, Global_1.globalTokens.oldTokens.colorLink]
});
const buttonTextFocusTextColor = new DesignToken_1.default({
    name: 'button-text-focus-textColor',
    parent: [Global_1.globalTokens.colorForegroundDefaultPrimary, buttonTextHoverTextColor]
});
const buttonTextBorderColor = new DesignToken_1.default({
    name: 'button-text-borderColor',
    parent: [Global_1.globalTokens.colorForegroundDefaultTransparent, Global_1.globalTokens.colorTransparent]
});
const buttonTextHoverBorderColor = new DesignToken_1.default({
    name: 'button-text-hover-borderColor',
    parent: [Global_1.globalTokens.colorBackgroundDefaultHover, Global_1.globalTokens.colorTransparent]
});
const buttonTextActiveBorderColor = new DesignToken_1.default({
    name: 'button-text-active-borderColor',
    parent: [Global_1.globalTokens.colorBackgroundDefaultActive, Global_1.globalTokens.colorTransparent]
});
const buttonTextFocusBorderColor = new DesignToken_1.default({
    name: 'button-text-focus-borderColor',
    parent: [Global_1.globalTokens.colorForegroundDefaultTransparent, buttonTextHoverBorderColor]
});
const buttonTextBackgroundColor = new DesignToken_1.default({
    name: 'button-text-backgroundColor',
    parent: [Global_1.globalTokens.colorForegroundDefaultTransparent, Global_1.globalTokens.colorTransparent]
});
const buttonTextHoverBackgroundColor = new DesignToken_1.default({
    name: 'button-text-hover-backgroundColor',
    parent: [Global_1.globalTokens.colorBackgroundDefaultHover, Global_1.globalTokens.colorTransparent]
});
const buttonTextActiveBackgroundColor = new DesignToken_1.default({
    name: 'button-text-active-backgroundColor',
    parent: [Global_1.globalTokens.colorBackgroundDefaultActive, Global_1.globalTokens.colorTransparent]
});
const buttonTextFocusBackgroundColor = new DesignToken_1.default({
    name: 'button-text-focus-backgroundColor',
    parent: [Global_1.globalTokens.colorForegroundDefaultTransparent, buttonTextHoverBackgroundColor]
});
const buttonTextDisabledBorderColor = new DesignToken_1.default({
    name: 'button-text-disabled-borderColor',
    parent: [
        Global_1.globalTokens.colorForegroundDefaultTransparent,
        Global_1.globalTokens.oldTokens.colorBorderNeutral
    ]
});
const buttonTextDisabledBackgroundColor = new DesignToken_1.default({
    name: 'button-text-disabled-backgroundColor',
    parent: [Global_1.globalTokens.colorForegroundDefaultTransparent, Global_1.globalTokens.colorTransparent]
});
const buttonTextDisabledTextColor = new DesignToken_1.default({
    name: 'button-text-disabled-textColor',
    parent: [
        Global_1.globalTokens.colorForegroundDefaultDisabled,
        Global_1.globalTokens.oldTokens.colorTextButtonDisabled
    ]
});
exports.buttonTokens = {
    buttonHeightSBorderRadius,
    buttonHeightMBorderRadius,
    buttonHeightLBorderRadius,
    buttonHeightS,
    buttonHeightM,
    buttonHeightL,
    buttonHeightSMinWidth,
    buttonHeightMMinWidth,
    buttonHeightLMinWidth,
    buttonHeightSIconMargin,
    buttonHeightMIconMargin,
    buttonHeightLIconMargin,
    buttonHeightSFontSize,
    buttonHeightMFontSize,
    buttonHeightLFontSize,
    buttonHeightSFontWeight,
    buttonHeightMFontWeight,
    buttonHeightLFontWeight,
    buttonHeightSLineHeight,
    buttonHeightMLineHeight,
    buttonHeightLLineHeight,
    buttonBorderWidth,
    buttonHeightSPaddingHorizontal,
    buttonHeightMPaddingHorizontal,
    buttonHeightLPaddingHorizontal,
    buttonPrimaryBackgroundColor,
    buttonPrimaryHoverBackgroundColor,
    buttonPrimaryActiveBackgroundColor,
    buttonPrimaryFocusBackgroundColor,
    buttonPrimaryTextColor,
    buttonPrimaryHoverTextColor,
    buttonPrimaryActiveTextColor,
    buttonPrimaryFocusTextColor,
    buttonPrimaryBorderColor,
    buttonPrimaryHoverBorderColor,
    buttonPrimaryActiveBorderColor,
    buttonPrimaryFocusBorderColor,
    buttonPrimaryDisabledTextColor,
    buttonPrimaryDisabledBackgroundColor,
    buttonPrimaryDisabledBorderColor,
    buttonSecondaryTextColor,
    buttonSecondaryHoverTextColor,
    buttonSecondaryActiveTextColor,
    buttonSecondaryFocusTextColor,
    buttonSecondaryBackgroundColor,
    buttonSecondaryHoverBackgroundColor,
    buttonSecondaryActiveBackgroundColor,
    buttonSecondaryFocusBackgroundColor,
    buttonSecondaryBorderColor,
    buttonSecondaryHoverBorderColor,
    buttonSecondaryActiveBorderColor,
    buttonSecondaryFocusBorderColor,
    buttonSecondaryDisabledTextColor,
    buttonSecondaryDisabledBackgroundColor,
    buttonSecondaryDisabledBorderColor,
    buttonAlternateTextColor,
    buttonAlternateHoverTextColor,
    buttonAlternateActiveTextColor,
    buttonAlternateFocusTextColor,
    buttonAlternateBorderColor,
    buttonAlternateHoverBorderColor,
    buttonAlternateActiveBorderColor,
    buttonAlternateFocusBorderColor,
    buttonAlternateBackgroundColor,
    buttonAlternateHoverBackgroundColor,
    buttonAlternateActiveBackgroundColor,
    buttonAlternateFocusBackgroundColor,
    buttonAlternateDisabledTextColor,
    buttonAlternateDisabledBackgroundColor,
    buttonAlternateDisabledBorderColor,
    buttonTextHeightSPaddingHorizontal,
    buttonTextHeightMPaddingHorizontal,
    buttonTextHeightLPaddingHorizontal,
    buttonTextBorderWidth,
    buttonTextDecoration,
    buttonTextTextColor,
    buttonTextHoverTextColor,
    buttonTextActiveTextColor,
    buttonTextFocusTextColor,
    buttonTextBorderColor,
    buttonTextHoverBorderColor,
    buttonTextActiveBorderColor,
    buttonTextFocusBorderColor,
    buttonTextBackgroundColor,
    buttonTextHoverBackgroundColor,
    buttonTextActiveBackgroundColor,
    buttonTextFocusBackgroundColor,
    buttonTextDisabledTextColor,
    buttonTextDisabledBackgroundColor,
    buttonTextDisabledBorderColor,
    buttonDisabledIconFilter,
    buttonDisabledIconOpacity
};
//# sourceMappingURL=Button.js.map